<nk-layout-centered andClass="login-width">
  <div>
    <ng-container *ngIf="authInfo.status === 'UNKNOWN_MS_TENANT_ID'">
      <div class="alert alert-warning">
        <!--    TODO: seems like we are still logged in after refreshing page here.-->
        <h4 [innerHtml]="'login.unknown_ms_tenant_id.title' | translate"></h4>

        <ul>
          <li>
            {{ 'login.unknown_ms_tenant_id.if_your_company_already_has_account' | translate }}
          </li>
          <li>
            {{ 'login.unknown_ms_tenant_id.if_you_have_been_invited' | translate }}
          </li>
        </ul>

        <p [innerHtml]="'login.unknown_ms_tenant_id.contact_sales' | translate"></p>
      </div>
    </ng-container>
    <nk-verify-email-error *ngIf="verifyEmailError" [localStorageEmail]="localStorageEmail"></nk-verify-email-error>
    <form (ngSubmit)="onLogin()" [formGroup]="loginForm" autocomplete="on">
      <p *ngIf="loginMessage && !verifyEmailError" [innerHtml]="loginMessage | translate"></p>
      <div [class.form-error-highlight]="showErrors" class="form-group mb-3">
        <label class="label" for="email">{{ 'login.login_form.email' | translate }}</label>
        <input
          #email
          [readonly]="forcedEmail"
          class="form-control"
          formControlName="email"
          id="email"
          required
          type="email" />
        <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors" class="text-danger mt-1">
          <div *ngIf="loginForm.controls.email.errors?.required">
            {{ 'login.login_form.email_required' | translate }}
          </div>
          <div *ngIf="loginForm.controls.email.errors?.invalidFormat">
            {{ loginForm.controls.email.errors.invalidFormat | translate }}
          </div>
        </div>
      </div>
      <div (capsLock)="capsOn = $event" [class.form-error-highlight]="showErrors" class="form-group mb-3" nkCapsLock>
        <label class="label" for="password">{{ 'login.login_form.password' | translate }}</label>
        <input
          #password
          autocomplete="off"
          class="form-control"
          formControlName="password"
          id="password"
          type="password" />
        <div *ngIf="capsOn" class="text-muted mt-2">
          {{ 'login.login_form.caps_lock_is_on' | translate }}
        </div>
      </div>
      <p *ngIf="errorDescription && !verifyEmailError" class="warning">{{ errorDescription | translate }}</p>
      <div class="row no-gutters">
        <div class="col-6">
          <button [block]="true" color="success" id="login" nkButton size="lg">
            {{ 'login.login_form.login_btn' | translate }}
          </button>
        </div>
        <div class="col-6 align-self-center">
          <div class="ms-2 text-right">
            <nk-risk-password-reset-link
              [changePasswordText]="'login.login_form.forgot_password' | translate"></nk-risk-password-reset-link>
          </div>
        </div>
      </div>
    </form>
    <!--<hr>-->
    <div class="mt-2 mb-2">
      <div class="horizontal-line-around">
        <span class="mx-3 small">{{ 'login.enterprise.for_enterprise' | translate }}</span>
      </div>
      <button (click)="redirectLogin('enin-ad')" [block]="true" [ghost]="true" andClass="mt-2" color="primary" nkButton>
        <i class="fa fa-windows me-2"></i> {{ 'login.enterprise.log_in_with_microsoft' | translate }}
      </button>
    </div>
    <hr />
    <div *ngIf="enableSelfServiceOnboarding">
      <p class="text-center mb-2">{{ 'login.dont_have_account' | translate }}</p>
      <p class="text-center">
        <a [routerLink]="['/sign-up']" color="primary" id="sign_up" nkButton>{{ 'login.try_enin_now' | translate }}</a
        ><br />
      </p>
    </div>
    <p class="text-center">
      <span [innerHtml]="'login.help' | translate" class="small"></span>
    </p>
  </div>
</nk-layout-centered>
